import { Injectable } from '@angular/core';
import {algoliasearch, SearchParams, SearchResponse} from 'algoliasearch';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  public searchClient = algoliasearch(
    '49L6P6WVVE',
    '65e5e76bff80e7352780fc78c53a89d6'
  );

  private latest = new Map<string, number>();

  constructor(
  ) { }

 
  public search(indexName: string, params?: SearchParams, channel?: string): Promise<SearchResponse | null> {
    const key = channel || indexName;
    const token = (this.latest.get(key) ?? 0) + 1;
    this.latest.set(key, token);

    return this.searchClient.searchSingleIndex({indexName: indexName, searchParams: params}).then((resp) => {
      if (this.latest.get(key) !== token) {
        return null;
      }
      return resp;
    });
  }
}
